/*
 * Copyright (c) 2022-2025.  atagon GmbH.  All rights reserved.
 *
 * This file is part of the atagon codebase and may not be copied,
 *  distributed, or modified without explicit written permission from
 * atagon GmbH. https://www.atagon.com
 */

import React, {Component} from 'react';
import GlobalPortal from "./GlobalPortal.jsx";
import DisplayIcon from "./Icons/DisplayIcon.jsx";
import PropTypes from "prop-types";

class FakeCursor extends Component {

    constructor() {
        super();

        this.cursorDiv = React.createRef()
    }

    onMove = (event) => {
        if (this.cursorDiv.current !== null) {
            let mouseY = event.clientY ?? event.touches[0].clientY;
            let mouseX = event.clientX ?? event.touches[0].clientX;

            if (this.props.lockX) {
                mouseX = this.props.startPos.clientX
            }

            if (this.props.lockY) {
                mouseY = this.props.startPos.clientY
            }

            this.cursorDiv.current.style.transform = `translate3d(${mouseX}px, ${mouseY}px, 0)`;
        }
    }

    componentDidMount() {
        document.documentElement.style.cursor = 'none';
        document.addEventListener('mousemove', this.onMove)
        document.addEventListener('touchmove', this.onMove)
    }

    componentWillUnmount() {
        document.documentElement.style.cursor = 'auto';
        document.removeEventListener("mousemove", this.onMove);
        document.removeEventListener("touchmove", this.onMove);
    }

    render() {
        let {allowClick, iconName, color = "black", size = "1.9em"} = this.props

        return (
            <GlobalPortal>
                <div
                    className={`top-0 left-0 fixed w-screen h-screen cursor-none touch-none ${allowClick ? ("pointer-events-none") : ("pointer-events-auto")}`}>

                    {/*The fake courser */}
                    <div ref={this.cursorDiv}
                         className={"fixed transform will-change-transform"}>
                        <div className={" "} style={{transform: "translate(-50%, -50%)"}}>
                            <DisplayIcon iconName={iconName} size={size} color={color}/>
                            {this.props.display}
                        </div>


                    </div>
                </div>
            </GlobalPortal>
        );
    }
}

FakeCursor.propTypes = {
    lockY: PropTypes.bool,
    lockX: PropTypes.bool,
    allowClick: PropTypes.bool,

};

FakeCursor.defaultProps = {
    lockY: false,
    lockX: false,
    allowClick: false,
}
export default FakeCursor;